
import { Component, Vue, Watch } from "vue-property-decorator";

import FormBase from "@/lib/view-base/formbase";
import { CouponService, UpdateCouponDto } from "@/api/service-proxies";
import SelectTree from "@/components/SelectTree/SelectTree.vue";
import WangEditor from 'wangeditor'
import appconst from "@/lib/appconst";
@Component({
    name: "UpdateProduc",
    components: {
        SelectTree,
    },
})
export default class CreateTenant extends FormBase {
    coupon: UpdateCouponDto = new UpdateCouponDto();
    couponService: CouponService = new CouponService();
    productCategoryType: any = [];
    rules: object = {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
       productId: [
            { required: true, message: "请选择选择产品", trigger: "blur" },
        ],

        introduction: [],
        isRegisterd: [],
        organizationUnitId: [],
    };
    buttonlist: any = []
    defaultProps = {
        parent: "parentId", // 父级唯一标识
        value: "id", // 唯一标识
        label: "displayName", // 标签显示
        children: "children",
    };
    options=[ // 下拉选项数组
        { label: '滚动图', value: '1' },
        { label: '直播图', value: '2' },
        // 可以继续添加更多选项
    ]
    imageUploadAction = appconst.remoteServiceBaseUrl + 'sysadmin/UploadFile/ProductUpload'
    inputValue2: any = '' // 正文内容  textarea框值
    CouponImg = ''
    mounted() {



        this.getCoupon(+this.$route.params["id"]);
    }
    async getCoupon(id: number) {
        this.initProduct();
        let Coupon = await this.couponService.get(id);
        this.coupon = <UpdateCouponDto>Coupon;



    }


    created() { }
    async submitExecute(): Promise<void> {
        await this.couponService.update(this.coupon);
    }

    //获取商品分类的数据
    initProduct() {
        var _that = this;
        this.couponService.getProductAll().then(res => {
            _that.productCategoryType = res;
        });
    }
   
}
